import {Component, Injector, OnDestroy, ViewChild} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {TechnicalDeviceApiService} from '@api/technical-device.api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalComponent} from '@components/modal/modal.component';
import {TechnicalDeviceDocumentTypesProvider} from '@providers/dechnical-device-document-types/technical-device-document-types.provider';
import {TechnicalDeviceDataService} from '../../services/technical-device-data.service';
import {TechnicalDeviceDocumentApiService} from '@api/technical-device-document.api.service';
import {FormHelperService} from '@services/form-helper.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-device-document-form-modal',
    templateUrl: 'device-document-form-modal.component.html'
})

export class DeviceDocumentFormModalComponent extends FrontendFormComponent implements OnDestroy {
    @ViewChild(ModalComponent) private modal: ModalComponent;

    public afterSaveMessage = NotyMessagesEnum.technicalDeviceDocumentationUpdateMessage;

    public form = this._fb.group({
        id: [''],
        type: [''],
        name: [''],
        files: this._fb.array([])
    });

    public fetchingData = true;

    private id: number;

    constructor(
        injector: Injector,
        public formService: TechnicalDeviceApiService,
        public typesProvider: TechnicalDeviceDocumentTypesProvider,
        private dataService: TechnicalDeviceDataService,
        private documentsApi: TechnicalDeviceDocumentApiService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        super(injector);
    }

    init() {
        this.id = this.route.snapshot.params.documentationId;

        if (this.id) {
            this.documentsApi.get({
                id: this.id
            }).pipe(
                untilDestroyed(this)
            ).subscribe((documentation) => {
                if (documentation) {
                    FormHelperService.setFormValues(documentation, this.form);
                }
                this.fetchingData = false;
            }, () => {
                this.fetchingData = false;
            });
        } else {
            this.fetchingData = false;
        }
    }

    get saveUrl(): string {
        return this.formService.getDocumentPath(this.dataService.deviceId);
    }

    afterSave() {
        super.afterSave();
        if (this.id) {
            this.dataService.documentationUpdated$.next();
        } else {
            this.dataService.documentationCreated$.next();
        }
        this.modal.close();
    }

    onModalClose() {
        this.router.navigate([{outlets: {modal: null}}], {relativeTo: this.route.parent.parent});
    }

    ngOnDestroy(): void {

    }
}
